<div id="dashboard" [ngClass]="{ displayedSysAlerts: displayedSysAlerts().length > 0 }">
  @if (displayedSysAlerts().length > 0) {
    <div id="sysAlertContainer">
      @for (alert of displayedSysAlerts(); track alert) {
        <div class="customAlert">
          <span class="alertMessage">{{ alert.message }}</span>
          <button class="alertClose" (click)="closeAlert(alert)">×</button>
        </div>
      }
    </div>
  }
  <app-side-bar [notificationCount]="notificationState.unreadCount()"></app-side-bar>
  <router-outlet style="display: none"></router-outlet>
  <app-confirm-popup key="global"></app-confirm-popup>
</div>
